import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgRemoveAlt = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", d: "M19.026 20.418L3.582 4.974c-.436-.436-.432-1.095-.067-1.46.364-.364 1.06-.332 1.46.068l15.443 15.444c.436.436.432 1.095.067 1.46-.364.364-1.059.332-1.459-.068z" }),
        React.createElement("path", { fill: "currentColor", d: "M20.418 4.974L4.974 20.418c-.436.436-1.094.432-1.46.067-.364-.364-.332-1.06.068-1.459L19.026 3.582c.436-.436 1.095-.432 1.46-.067.364.364.332 1.06-.068 1.459z" })));
};
export default SvgRemoveAlt;
//# sourceMappingURL=RemoveAlt.js.map